import type { BaseTranslation } from '../i18n-types';

export const dialogs = {
    report: {
        title: 'Report user',
        send: 'Send report',
        success: 'The report has been sent',
    },
    rating: {
        title: 'Chat with {userName:string} ended',
        subtitle: 'How was the conversation?',
        subtitleBadRated: 'We are sorry! What was wrong?',
        subtitleGoodRated: 'Thanks! What did you like the most?',
        buttonFavorite: 'Add {userName:string} to favorites',
        buttonSearch: 'Continue searching',
        buttonSubmit: 'Submit',
        tagComment: 'Add a comment',
        tagVideo: 'Video quality',
        tagBoringConversation: 'Boring conversation',
        nudity: 'Before resuming the random call, make sure your outfit meets <a class="link {classes:string}" href="{termsOfUseLink:string}" target="_blank">chat rules</a>',
    },
    ratingUser: {
        tagSuddenlyLeft: 'Suddenly he left the chat',
        tagUnacceptable: 'Pushing to unacceptable behavior',
        tagBullying: 'Bullying',
        tagHate: 'Hate speech',
        tagGenerosity: 'Generosity',
        tagPleasant: 'Pleasant appearance',
        tagRespectful: 'Respectful attitude',
        tagConversation: 'The conversation',
    },
    ratingOperator: {
        title: 'Chat with {operatorName:string} ended',
        titleRated: 'You rated {operatorName:string} {emoji:string}',
        subtitleNormalRated: 'Good, but not perfect. What was wrong?',
        tagSuddenlyLeft: 'Suddenly she left the chat',
        tagBeggingGifts: 'Begging for gifts',
        tagConversation: 'Conversation',
        tagAttitude: 'Attitude during the call',
        tagAppearance: 'Appearance',
        tagAttractiveness: 'Attractiveness',
        commentTitle: 'Please, tell us what was wrong',
        giftSent: 'The gift has been sent to {operatorName:string}',
    },
    chooseGift: {
        title: 'Send a gift to {displayName:string}',
        balance: 'Your balance: <span>{minutes:string}</span>',
        priceSeconds: 'Cost: {minutes:string}',
        priceReceived: 'You got: {price:string}',
        price: 'You’ll get: {price:string}',
        titleAsk: 'Ask for a gift from {displayName:string}',
        custom: 'Custom',
    },
    confirmGift: {
        title: '{displayName:string} asks you for a gift',
        request: 'Please give me a gift {gift:string}!',
    },
    customGift: {
        title: 'Send a special gift',
        label: 'Custom amount:',
        sendGift: 'Send gift',
        somethingWrong: 'Something went wrong',
    },
    vpnDetected: {
        close: 'Close',
        title: 'VPN detected',
        text: 'You must have membership to use VPN or proxy server for your security',
        getMemberShip: 'Get Membership',
    },
    resetPassword: {
        title: 'Reset your password',
        subtitle: `Enter the email you use for {appName:string}`,
        inputPlaceholder: 'Your email',
        mainButton: 'Get a recovery link',
        backToLogin: 'Back to login',
        wrongEmail: 'Please enter a part following \'@\'. \'<user\'s email>\' is incomplete.',
    },
    resetPasswordSent: {
        title: 'Reset your password',
        subtitle:
            '<b>We have sent you a recovery link.</b> If your email address is valid, you will receive it. <b>Check your spam folder</b> if you haven\'t received the email.',
    },
    passwordRecovery: {
        title: 'Password recovery',
        subtitle: 'Please enter new password',
        firstInputPlaceholder: 'New password',
        secondInputPlaceholder: 'Repeat a new password',
        mainButton: 'Change password',
        closeButton: 'Back to the main page',
    },
    passwordRecoverySuccess: {
        title: 'Success',
        subtitle: 'Your password has been changed.',
        closeButton: 'Back to login',
    },
    passwordRecoveryLinkExpired: {
        title: 'Your link expired',
        subtitle:
            'Your link for restoring password doesn\'t work: probably it was entered incorrectly or expired after 24 hours.',
        requestNewLinkBtn: 'Request a new link',
    },
    warning: {
        title: 'Reports of Policy Violation Detected',
        titleV2: 'Report of Policy Violation Detected',
        subtitleStart: 'We have received multiple reports regarding your account involving ',
        nudity: 'Nudity or explicit content are strictly prohibited during the first two minutes in Random Calls.',
        nudityV2: 'Nudity or explicit content are strictly prohibited with Guests.',
        subtitleEnd: 'Continued violations of our rules may result in a ban. Please review all the rules outlined in our <a href="{termsOfUseLink:string}" class="link "target="_blank">Terms of Use</a>',
        subtitleEndOperator: 'Continued violations of our rules may result in a ban. Please review all our rules <a href="{chatRules:string}" class="link" target="_blank">here</a>',
        btn: 'Got it, no more violations',
    },
    userAgreement: {
        title: 'Please read our rules carefully',
        ruleAdult: 'You must be 18 years or older',
        ruleBan: 'Violating these rules may result in warnings, temporary or permanent account suspension, with funds being withheld.',
        preRecorded: 'Streaming pre-recorded content instead of live video, streaming someone else\'s video as your own, leaving the camera unattended during live streams, or ignoring users during chats is prohibited.',
        nudity: 'Nudity or explicit content is strictly prohibited during the first two minutes in Random Calls.',
        nudityStrict: 'Nudity or explicit content is strictly prohibited with Guests.',
        prohibitedContent: 'Prohibited Content: inappropriate content or material (including depicting of animal cruelty, rape, violence, necrophilia, threat of suicide or harm to self or others, blood, feces, vomit) and any form of Illegal activities, harassment, violence, hate speech, and any form of discrimination are prohibited.',
        minors: 'Involvement of minors in any capacity is strictly forbidden.',
        contacts: 'Sharing personal contact details is not safe and not allowed.',
        links: 'Sharing links to external platforms is prohibited.',
        recording: 'Recording or distributing chat content is strictly prohibited.',
        payments: 'All payments must be processed through the platform\'s payment system. Requesting or receiving funds outside the platform is forbidden.',
        payouts: 'Compensation is based on chat duration. Only the account owner is eligible to receive payments for collaborations.',
        fraudulent: 'Fraudulent financial activities, including deceiving users for gifts or other benefits, asking for money under false pretenses, and providing the false and misleading information, are not allowed.',
        fullTerms: 'For the full terms and conditions, visit the&nbsp;<a href="{termsOfUseLink:string}" class="link" target="_blank"><b>Agreement</b></a>.',
        ruleNoBulling: 'No bulling or hate speech',
        ruleNoWeapon: 'No content involving weapon, rape, gore, etc',
        ruleNoSpam: 'No spam or scam',
        text1: 'Important Information! By using this Website, Services and by participating in Chats, you confirm that you agree with our Terms and Conditions of Use (Agreement) and Privacy Policy. When using the Application it’s also STRICTLY PROHIBITED to:',
        list1Item1: 'Be in chat if you are younger than 18 years old',
        list1Item2: 'Be naked in front of the camera;',
        list1Item3: 'Show the genitals or touch the genitals even through clothes;',
        list1Item4: 'Broadcast photo/video Content of erotic/pornographic nature;',
        text2: 'Before participating in Chats and by clicking “I confirm” or similar button on this page, you confirm that you are at least eighteen (18) or twenty-one (21) years of age, depending on the age of majority in your jurisdiction (“age of majority”), that you have the legal capacity to enter into Chats and that you agree to the terms below:',
        list2Item1: `You represent and warrant that you will not allow persons under the age of majority to use the {appName:string} Website and Services, communicate through the Chats, or perform any other actions which can be carried out through the {appName:string} Website and Services.`,
        list2Item2:
            'You represent and warrant that anyone appearing on camera with you has also reached the age of majority.',
        list2Item3: `You represent and warrant that you will immediately report to us any and all instances where an individual who has not reached the age of majority is using the {appName:string} Website and Services, or any individual is broadcasting photo or video content involving persons under the age of majority.`,
        list2Item4: `If {appName:string} has any reasonable grounds for suspecting that you are under the age of majority, your account will be blocked permanently.`,
        list2Item5:
            'Unless you meet the requirements specified in our Terms and Conditions of Use (Agreement), you agree and confirm that you will not display content of an adult nature. We may take action in the event of a breach of this rule.',
        acceptButton: 'Accept',
        agreeButton: 'I agree',
    },
    disablePackageMinutesAutoRenew: {
        title: 'Are you sure you want to disable automatic top ups?',
        subtitle:
            'Your balance will no longer be automatically topped up, and you will need to keep track of your remaining time.',
        keepItOn: 'Keep it on',
        successMessage: 'Automatic balance top up is disabled',
    },
    contest: {
        title: `{nameShort:string} Contest 🏆`,
        giftCosts: 'Gift costs',
        rulesPrizes: {
            title: 'Rules and prizes',
            prizesInfo: 'Special gifts have already appeared on the site. Earn as many gifts (marked with the special symbol 🏆) as possible. Top-10 models will receive an additional $100 to your payout!',
            endDataInfo: `The contest ends {utcDate:string}th {utcMonth:string} at {utcTime:string} UTC.`,
        },
    },
} satisfies BaseTranslation;
